<template>
  <div class="chat-item">
    <ChatText :message="message" :type="type" :index="index" @onLinkTitleClick="onLinkTitleClick" @updateContentHeight="onUpdateContentHeight" v-if="message.msgType == 1 && message.aiRespFlag < 2"@controls="onControls" @animationFinish="onAnimationFinish" @resetSendQusition="onResetSendQusition" />
    <ChatTemporaryItem :message="message" :type="getTemporaryType()" @updateContentHeight="onUpdateContentHeight" v-if="message.msgType == 2" @resetSendQusition="onResetSendQusition" />
    <ChatAICheck :message="message" :type="type" :index="index" @updateContentHeight="onUpdateContentHeight" v-if="message.aiRespFlag == 2" @aICheck="onAICheck" />
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
const { t } = useI18n()
import useUserStore from "@/store/modules/user";
import {storeToRefs} from "pinia";

import ChatText from "@/components/PDFChatComponents/ChatItem/ChatText.vue"
import ChatAICheck from "@/components/PDFChatComponents/ChatItem/ChatAICheck.vue"
import ChatTemporaryItem from "@/components/PDFChatComponents/ChatTemporaryItem/ChatTemporaryItem.vue"
import type { Message } from '@/data/chat/Message';

const userStore = useUserStore();

let call = defineEmits(["updateContentHeight", "controls", "animationFinish", "resetSendQusition", "proBuy", "aICheck", "onLinkTitleClick"])

const { userInfo } = storeToRefs(userStore);

interface Props {
  // type: number,  // 0 源文语言 1 目标语言
  message: Message 
  index: number
  type?: number // 2 代表ai 翻译
}
const props = defineProps<Props>()

const getTemporaryType = () => {
  if (userInfo.value.vipLevel == 0) {
    return 2
  }else if (userInfo.value.vipLevel > 0) {
    return 3
  }else{
    return 1
  } 
}

function onAICheck(item) {
  call("aICheck", item)
}

function onLinkTitleClick() {
  call("onLinkTitleClick")
}

function onUpdateContentHeight() {
  call("updateContentHeight")
}

function onControls(index) {
  call("controls", index)
}

function onAnimationFinish() {
  call("animationFinish")
}

function onResetSendQusition(content) {
  call("resetSendQusition", content)
}

onMounted(()=>{
 
})

</script>

<style lang="less" scoped>
.chat-item {
  padding: 10px 0px;
  position: relative;
}

</style>
